var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDateIcon = function SvgDateIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 20,
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m15.8337 2.50065h.8333c.9167 0 1.6667.75 1.6667 1.66667v13.33338c0 .9166-.75 1.6666-1.6667 1.6666h-13.33334c-.91667 0-1.66667-.75-1.66667-1.6666v-13.33338c0-.91667.75-1.66667 1.66667-1.66667h.83333v-.83333c0-.45834.375-.833336.83334-.833336.45833 0 .83333.374996.83333.833336v.83333h8.33334v-.83333c0-.45834.375-.833336.8333-.833336.4584 0 .8334.374996.8334.833336zm-11.66671 15.00005h11.66671c.4583 0 .8333-.375.8333-.8334v-9.99998h-13.33334v9.99998c0 .4584.375.8334.83333.8334z",
    fill: "#777776",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDateIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/date_icon.37413bbb.svg";
export { ForwardRef as ReactComponent };